import { URI } from '@fiverr-private/futile/lib/url/URI';
import { gofor } from '@fiverr-private/futile/lib/gofor';
import pathfinder from '@fiverr-private/pathfinder';
import request from './request';
import localStorageService from './localStorage';

export default {
    fetch: ({ sortBy }, activeFilters, appContext) => {
        const gigIds = localStorageService.getRecentlyViewedGigs();
        const { showTranslatedUGC = false, knownCrawler, locale } = appContext;
        const translationUgcData = {
            session_locale: locale,
            showTranslatedUGC,
            knownCrawler,
            translate_ugc: showTranslatedUGC.toString()
        };

        return request.post('fetch_recently_viewed', { gig_ids: gigIds,
            sortBy,
            activeFilters,
            ...translationUgcData
        });
    },

    clearAllRecentlyViewedGigs: (loggedIn) => {

        if (loggedIn) {

            const url = new URI(pathfinder('clear_recently_viewed_gigs')).toString();

            return gofor(url, {
                method: 'DELETE'
            });
        }

        return localStorageService.removeAllRecentlyViewedGigs();
    },

    clearRecentlyViewedGig: (loggedIn) => {

        if (loggedIn) {
            return undefined;
        }

        return localStorageService.removeSingleRecentlyViewedGig;
    },

    recentlyViewedPageURL: () => pathfinder('generic_recommendations_page', {
        page_name: 'recently_viewed_page'
    })
};
